import styled from "vue-styled-components";

export const SHeading = styled.h2`
  margin: 2px 0;
  font-family: ${({ theme }) => theme.font.family.inter}, sans-serif;
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  font-size: ${({ theme }) => theme.font.size.xl};
  line-height: 140%;
  color: ${({ theme }) => theme.colors.neutral.gray8};
`;

export const SCard = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.white};
  border-radius: 8px;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.1);

  header {
    padding: 24px;
    text-align: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.gray1};
  }

  body {
    padding: 24px;
  }
`;

export const SDoctorSelect = styled.section`
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.colors.neutral.gray1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.gray1};
`;

export const SDoctorSchedule = styled.section`
  padding: 24px;
`;

export const SSelectedDoctor = styled.div`
  padding: 24px;
  display: flex;
  align-items: center;

  h4 {
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.semiBold};
    font-size: ${({ theme }) => theme.font.size.md};
    color: ${({ theme }) => theme.colors.neutral.gray8};
  }

  span {
    display: block;
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-size: ${({ theme }) => theme.font.size.sm};
    color: ${({ theme }) => theme.colors.neutral.gray6};
  }
`;

export const SSelectedDoctorInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
